import config from '../..//services/config';
import BaseDrawingObject from "./baseDrawingObject";


class Polygon extends BaseDrawingObject {

    constructor() {
        super();
        this.pointsArray = [];
        this.fillColour = null;
        this.closedPath = false;
        this.name = '';
        this.type = 'poly';

        // this.drawingGroupName = config.CHASSIS_OBJECT_TYPES.VEHICLE;
        // function setDrawingGroupName(group) {
        //     this.drawingGroupName = group;
        // }
        // this.setDrawingGroupName = setDrawingGroupName;
        this.setColour = function (colour) {
            this.colour = colour;
        }

        this.bypassHitAreaSort = false;
        this.setBypassHitAreaSort = function (newValue) {
            this.bypassHitAreaSort = newValue;
        }

        this.setDrawingOrder = function (newValue) {
            this.drawingOrder = newValue;
        }

        // this.setBringToFront = function (newValue) {
        //     this.bringToFront = newValue;
        // }

        // this.setLineWidth = function (newValue) {
        //     this.lineWidth = newValue;
        // }

        this.setAlpha = function (newValue) {
            this.alpha = newValue;
        }

        this.setFillPolygon = function (newValue) {
            this.fillPolygon = newValue;
        }
    }
}

export default Polygon;

